var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-main",
    { attrs: { id: "register-alternate" } },
    [
      _vm.success
        ? _c("div", { attrs: { id: "nomination-success" } }, [
            _c("h3", [_vm._v("Registration successful")]),
            _vm._v(" "),
            _c("p", [_vm._v("Thank you for registering an alternate.")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "We have now emailed this alternate notifying them of this."
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Once the alternate either accepts or declines this registration you will be notified via email."
              ),
            ]),
          ])
        : _vm.initError
        ? _c("div", [
            _c("p", [
              _vm._v(
                "It seems that you have already nominated an alternate, or your position as a State Council Delegate is no\n      longer valid."
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("Please call head office on "),
              _c(
                "a",
                { staticClass: "tel", attrs: { href: "tel:0263560300" } },
                [_vm._v("02 6356 0300")]
              ),
              _vm._v(" for further details."),
            ]),
          ])
        : _vm.nominationError
        ? _c(
            "div",
            { attrs: { id: "nomination-error" } },
            [
              _c("h3", [_vm._v("Sorry, we encountered an error")]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.nominationError))]),
              _vm._v(" "),
              _c("p", [
                _vm._v("Please call head office on "),
                _c(
                  "a",
                  { staticClass: "tel", attrs: { href: "tel:0263560300" } },
                  [_vm._v("02 6356 0300")]
                ),
                _vm._v(" for further details."),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.retry } },
                [_vm._v("\n      Try again\n    ")]
              ),
            ],
            1
          )
        : _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
            },
            [
              _c("div", {
                attrs: { id: "nomination-process-description" },
                domProps: {
                  innerHTML: _vm._s(_vm.nominationProcessDescription),
                },
              }),
              _vm._v(" "),
              _c(
                "el-card",
                {
                  staticClass: "person-details",
                  attrs: { id: "delegate-details", shadow: "never" },
                },
                [
                  _c("h4", [_vm._v("Your details")]),
                  _vm._v(" "),
                  _c("h3", [_vm._v(_vm._s(_vm.delegate.fullName))]),
                  _vm._v(" "),
                  _vm.delegate.mobile
                    ? _c("p", [_vm._v(_vm._s(_vm.delegate.mobile))])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.delegate.email))]),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "nominationForm",
                  staticClass: "body-normal",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-position": "top",
                  },
                },
                [
                  _vm.validationError
                    ? _c("el-alert", {
                        attrs: {
                          title: _vm.validationError,
                          type: "warning",
                          effect: "dark",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label:
                          "Select the Body you wish to nominate an alternate for",
                        prop: "branch",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "Select Body " },
                          model: {
                            value: _vm.form.branch,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "branch", $$v)
                            },
                            expression: "form.branch",
                          },
                        },
                        _vm._l(_vm.branchOptions, function (branch) {
                          return _c("el-option", {
                            key: branch.value,
                            attrs: { label: branch.label, value: branch.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", { attrs: { id: "rules" } }, [
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.showModal = !_vm.showModal
                          },
                        },
                      },
                      [
                        _vm._v(
                          "Rules for who is eligible to be nominated as an alternate\n          can be found by clicking here."
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("h3", [_vm._v("Proposed alternate")]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { sm: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "First Name",
                                prop: "nominee.firstName",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: !_vm.branchOptions.length,
                                  placeholder: "First name",
                                  required: "",
                                },
                                model: {
                                  value: _vm.form.nominee.firstName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form.nominee, "firstName", $$v)
                                  },
                                  expression: "form.nominee.firstName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { sm: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Last Name",
                                prop: "nominee.lastName",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: !_vm.branchOptions.length,
                                  placeholder: "Last name",
                                  required: "",
                                },
                                model: {
                                  value: _vm.form.nominee.lastName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form.nominee, "lastName", $$v)
                                  },
                                  expression: "form.nominee.lastName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { sm: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "Email", prop: "nominee.email" },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: !_vm.branchOptions.length,
                                  placeholder: "Email",
                                  required: "",
                                },
                                model: {
                                  value: _vm.form.nominee.email,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form.nominee, "email", $$v)
                                  },
                                  expression: "form.nominee.email",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { sm: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Mobile",
                                prop: "nominee.mobile",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: !_vm.branchOptions.length,
                                  placeholder: "Mobile",
                                },
                                model: {
                                  value: _vm.form.nominee.mobile,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form.nominee, "mobile", $$v)
                                  },
                                  expression: "form.nominee.mobile",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "submit" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled: !_vm.branchOptions.length,
                          },
                          on: { click: _vm.submitNomination },
                        },
                        [_vm._v("\n          Submit\n        ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "ModalShell",
        {
          attrs: {
            id: "nomination-modal",
            title: "Alternate Eligibility Rules",
            show: _vm.showModal,
          },
          on: {
            close: function ($event) {
              _vm.showModal = false
            },
          },
        },
        [_c("div", { domProps: { innerHTML: _vm._s(_vm.nomineeRules) } })]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }